import { render, staticRenderFns } from "./MapaCalorNovedades.vue?vue&type=template&id=71293cb9&scoped=true"
import script from "./MapaCalorNovedades.vue?vue&type=script&lang=js"
export * from "./MapaCalorNovedades.vue?vue&type=script&lang=js"
import style0 from "./MapaCalorNovedades.vue?vue&type=style&index=0&id=71293cb9&prod&scoped=true&lang=css"
import style1 from "./MapaCalorNovedades.vue?vue&type=style&index=1&id=71293cb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71293cb9",
  null
  
)

export default component.exports